define('collections/distributor_roles',['require','collections/base','models/distributor_role'],function (request) {
    var BaseCollection = require('collections/base');
    var Model = require("models/distributor_role");
    return BaseCollection.extend({
        model : Model,
        url:"distributor-roles.json"
    });
});
